import { toast } from '@hakimo-ui/hakimo/util';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useSendAudio(
  cameraId: string | null,
  alarmId?: string,
  locAlarmId?: string,
  onSuccess?: () => void,
  escalationId?: string,
  product: 'scan' | 'remote-guarding' | 'enterprise' = 'remote-guarding'
) {
  const params = new URLSearchParams();
  if (alarmId) {
    params.append('alarmId', alarmId);
  }
  if (product === 'scan') {
    if (locAlarmId) {
      params.append('alarmGroupId', locAlarmId);
    }
    params.append('product', 'scan');
    if (escalationId) {
      params.append('escalationId', escalationId);
    }
  } else {
    if (locAlarmId) {
      params.append('locationAlarmId', locAlarmId);
    }
    params.append('product', 'remote-guarding');
  }

  const url = `/v2/orm/camera/audio/${cameraId}?${params.toString()}`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<null, FormData>(request, {
    onSuccess,
    onError: () => {
      toast(
        'Talkdown failed — audio was not sent to the camera. Please retry.',
        {
          type: 'error',
        }
      );
    },
    getBody: (data) => data,
    onSuccessInvalidationKeys: [
      ['alarm_updates', alarmId ?? '', locAlarmId ?? ''],
      ['location_alarm_updates'],
    ],
  });
}

export default useSendAudio;
